/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {LayoutIncludeResource} from '../../../components/api/resources/resource/layout-include.resource';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-layout-include-route-page',
  template: `
    <adn-layout-include-list-page
      *ngIf="list"
      [list]="list">
    </adn-layout-include-list-page>
  `
})
export class LayoutIncludeRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(LayoutIncludeResource) private readonly LayoutInclude: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageLayouts.apiKey);

    this.adnListHelper.setUpList(this.list, this.LayoutInclude, readOnly, 'fullLayoutIncludeList', {
      baseTable: 'layoutInclude'
    });
  }
}
